import api from '../token';

export const AlterCliente = async (dados) => {
  try {
    const response = await api.post('/alterCliente', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};